import angular = require('angular');

export interface IImage {
    name: string;
    svg: string;
    png: string;
    folder: string;
    allowed_apps: Array<string>;
    description: string;
}

class IconService  {
    public images: Map<string, object> = new Map<string, object>();
    public fonts: Array<string> = [];
    public ready: Promise<any>;
    
    public static $inject = ['$http'];

    constructor($http) {
        this.ready = new Promise((resolve) => {
            const env = window.sps.$Constants.env === 'local' ? 'dev' : window.sps.$Constants.env;
            const iconJsonFile = window.sps.$Constants.appIcons + '/' + env + '.all-icons.json';
            $http.get(iconJsonFile).then((res) => {
                this.fonts = res.data.fonts;
                const images = res.data.images || [];
                images.forEach((image) => {
                    this.images.set(image.name, image);
                });
            }).finally(resolve);
        });
    }

    public whenReady() {
        return this.ready;
    }

    public getImage(name) {
        return this.images.get(name);
    }
}

export default angular
    .module('spsng.services.icon', [])
    .service('IconService', IconService)
    .name;
